import { render, staticRenderFns } from "./staffdialog.vue?vue&type=template&id=0b418c5f&scoped=true"
import script from "./staffdialog.vue?vue&type=script&lang=js"
export * from "./staffdialog.vue?vue&type=script&lang=js"
import style0 from "./staffdialog.vue?vue&type=style&index=0&id=0b418c5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b418c5f",
  null
  
)

export default component.exports